export default "__VITE_ASSET__7e2e5c3c__"